import React from "react";
import styled from "styled-components";
import InputDatePicker from "../../components/Datepicker";
import InputField from "../../components/InputField";
import SelectField from "../../components/SelectField";
import { Colors } from "../../config";
import { PAYMENT_TYPES, TRAVEL_CLASS } from "../../config/Constants";
import JourneyType from "./JourneyType";
import Button from "../../components/Button";
import UploadDocument from "../../components/UploadDocument";
const deleteIcon = require("../../assets/images/delete.png");

const GuestDetails = ({
  onRemove,
  guest,
  index,
  onGuestChange,
  onPaymentSelect,
  onTravelClassSelect,
  onPassportExpirySelect,
  guestError,
  handleDobSelect,
  handleUploadPassport,
  selectedFileName,
}) => {
  return (
    <GuestListContainer isEven={(index + 1) % 2 === 0} key={index + 1}>
      <GuestListHeader>
        <div>
          <GuestLabel>Guest {Number(index) + 1}</GuestLabel>
          <GuestDesciption>
            Your guest will be traveling on the same date and time as you.
          </GuestDesciption>
        </div>
        <div>
          <Button
            leftRightPadding={"1rem"}
            topBottomPadding={"0.75rem"}
            fontSize="0.875rem"
            label={"Remove"}
            rightImgSrc={deleteIcon}
            onClick={() => onRemove(index)}
            bgColor={Colors.pomegranate}
          />
        </div>
        {/* <RemoveLabel onClick={() => onRemove(index)}>Remove</RemoveLabel> */}
        {/* <JourneyType /> */}
      </GuestListHeader>
      <BookingWrapper>
        <InputWrapper>
          <InputField
            placeholder="First Name"
            label="First Name"
            value={guest.firstName}
            onChange={(e) => onGuestChange(e, index)}
            name="firstName"
            isRounded
            helperText={guestError?.firstName}
          />
        </InputWrapper>
        <InputWrapper>
          <InputField
            placeholder="Last Name"
            label="Last Name"
            value={guest.lastName}
            onChange={(e) => onGuestChange(e, index)}
            name="lastName"
            isRounded
            helperText={guestError?.lastName}
          />
        </InputWrapper>
        {/* <InputWrapper>
          <InputDatePicker label="Departure Date" />
        </InputWrapper>
        <InputWrapper>
          <InputDatePicker
            label="Return Date"
            value={""}
            onChange={(e) => console.log(e)}
          />
        </InputWrapper> */}
        <SelectField
          label="Payment Type"
          isRounded
          value={guest.paymentType}
          placeholder="Payment Type"
          data={PAYMENT_TYPES.filter((item) => item.value !== "company paid")}
          onChange={(e) => onPaymentSelect(e, index, "guests")}
          helperText={guestError?.paymentType}
        />
        <SelectField
          label="Travel Class"
          isRounded
          placeholder="Travel Class"
          value={guest.travelType}
          data={TRAVEL_CLASS}
          onChange={(e) => onTravelClassSelect(e, index, "guests")}
          helperText={guestError?.travelType}
        />
        <InputWrapper>
          <InputField
            label="Passport Number"
            placeholder="Passport Number"
            onChange={(e) => onGuestChange(e, index)}
            value={guest.passportNo}
            name="passportNo"
            isRounded
            helperText={guestError?.passportNo}
          />
        </InputWrapper>
        <InputWrapper>
          <InputDatePicker
            format="yyyy/MM/dd"
            placeholder="Passport Expiry"
            label="Passport Expiry"
            value={guest.passportExpiry}
            onChange={(val) => onPassportExpirySelect(val, index)}
            helperText={guestError?.passportExpiry}
            minDate={new Date()}
            dropdownMode="select"
          />
        </InputWrapper>
        <InputWrapper>
          <InputDatePicker
            format="yyyy/MM/dd"
            placeholder="Select Date"
            label="Date of Birth"
            value={guest.dob}
            onChange={(val) => handleDobSelect(val, index)}
            helperText={guestError?.dob}
            maxDate={new Date()}
            scrollableYearDropdown
            scrollableMonthDropdown
            dropdownMode="select"
          />
        </InputWrapper>
        <InputWrapper>
          <UploadDocument
            value={guest.passportPdf}
            onChange={(obj) => handleUploadPassport(obj, index)}
            helperText={guestError?.passportPdf}
            disabled={guest.passportPdf}
            index={index}
            selectedFileName={selectedFileName}
          />
        </InputWrapper>
      </BookingWrapper>
    </GuestListContainer>
  );
};

const GuestDesciption = styled.div`
  color: ${Colors.brandTwo};
  font-weight: 600;
  font-size: 0.875rem;
`;
const BookingWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 2rem;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const GuestListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > div {
    display: flex;
    flex-direction: column;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

const GuestLabel = styled.div`
  font-weight: 700;
  font-size: 1.25rem;
  color: ${Colors.shark};
`;

const InputWrapper = styled.div`
  width: 100%;
`;

const GuestListContainer = styled.div`
  margin-top: 1rem;
  padding: 2rem;
  background-color: ${(props) =>
    props.isEven ? Colors.azureishWhiteOpacity50 : Colors.brandFiveOpacity30};
  @media only screen and (max-width: 768px) {
    padding: 1rem;
  }
`;

const RemoveLabel = styled.div`
  color: ${Colors.brandTwo};
  text-decoration: underline;
`;

export default GuestDetails;
